import * as React from 'react';
import * as style from './style.css';
import { Spinner } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingScreen = () => {
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    children: /*#__PURE__*/_jsx(Spinner, {
      size: 24
    })
  });
};